import type { CSSProperties, InputHTMLAttributes, ReactNode } from 'react';

export interface InputProps
  extends Omit<InputHTMLAttributes<HTMLInputElement>, 'onChange' | 'style' | 'prefix'> {
  value?: string;
  onChange?: (value: string) => void;
  prefix?: ReactNode;
  suffix?: ReactNode;
  style?: CSSProperties;
}

export function Input({
  value,
  onChange,
  prefix,
  suffix,
  style,
  type = 'text',
  ...rest
}: InputProps) {
  return (
    <label
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        height: 'var(--apm-input-h)',
        padding: '0 12px',
        background: 'var(--apm-bg-2)',
        border: '1px solid var(--apm-line)',
        borderRadius: 'var(--apm-radius)',
        ...style,
      }}
    >
      {prefix && <span style={{ color: 'var(--apm-muted)', display: 'inline-flex' }}>{prefix}</span>}
      <input
        type={type}
        value={value}
        onChange={(e) => onChange?.(e.target.value)}
        style={{
          flex: 1,
          minWidth: 0,
          border: 'none',
          outline: 'none',
          background: 'transparent',
          color: 'var(--apm-ink)',
          fontFamily: 'var(--apm-font-body)',
          fontSize: 'var(--apm-text-base)',
        }}
        {...rest}
      />
      {suffix && <span style={{ color: 'var(--apm-muted)', display: 'inline-flex' }}>{suffix}</span>}
    </label>
  );
}

export interface TextareaProps {
  value?: string;
  onChange?: (value: string) => void;
  placeholder?: string;
  rows?: number;
  style?: CSSProperties;
  name?: string;
  id?: string;
}

export function Textarea({
  value,
  onChange,
  placeholder,
  rows = 3,
  style,
  name,
  id,
}: TextareaProps) {
  return (
    <textarea
      name={name}
      id={id}
      value={value}
      onChange={(e) => onChange?.(e.target.value)}
      placeholder={placeholder}
      rows={rows}
      style={{
        width: '100%',
        resize: 'vertical',
        padding: '10px 12px',
        background: 'var(--apm-bg-2)',
        color: 'var(--apm-ink)',
        border: '1px solid var(--apm-line)',
        borderRadius: 'var(--apm-radius)',
        fontFamily: 'var(--apm-font-body)',
        fontSize: 'var(--apm-text-base)',
        lineHeight: 1.5,
        ...style,
      }}
    />
  );
}
